import { useIntl } from "@components/Intl"
import IntlLink from "@components/Intl/IntlLink"
import { Label } from "@components/Typography"
import { productGroupToUid } from "@config/general"
import imgix from "@config/imgix"
import { ArticleCombinationsByIdQuery } from "@generated"
import formatPrice from "@lib/formatPrice"
import React from "react"
import * as S from "./elements"

type Props =
  ArticleCombinationsByIdQuery["choicesArticleCombinationsById"][0] & {
    type: "article-combination" | "single-product"
  }

export const Product: React.FC<Props> = ({
  id,
  name,
  price,
  slug,
  product_group,
  images,
  type,
}) => {
  const { messages } = useIntl()
  const image = images
    ? imgix({
        key: images[0].path.replace(".png", ""),
        type: "articleCombination",
        args: { w: 200, h: 200 },
      })
    : imgix({
        key: id,
        type: "article",
        args: { w: 250, h: 250 },
      })

  // Get urls
  const href =
    messages.navigation[
      type === "article-combination"
        ? "collectionProductDetail"
        : "separateItemsProductDetail"
    ].url
  if (!product_group) {
    return null
  } else {
    let as = `${
      messages.navigation[productGroupToUid[product_group]].url
    }/${slug}-${id}`
    return (
      <IntlLink href={href} as={as}>
        <S.Anchor>
          <S.ImgWrapper>
            <img src={image} alt={name} />
          </S.ImgWrapper>
          <S.InfoWrapper>
            <S.Title as="h3">{name}</S.Title>
            <Label>{formatPrice(price)}</Label>
          </S.InfoWrapper>
        </S.Anchor>
      </IntlLink>
    )
  }
}
